import { FiSearch } from "react-icons/fi";
import CheckIcon from "components/icons/Check";
import { useEffect, useMemo, useRef, useState } from "react";
import AtriumApi from "api";
import Avatar from "components/avatar";
import toast from "react-hot-toast";
import Loader from "components/loader/Loader";

const AssignForm = ({ draggable, selected, setSelected }) => {
  const [users, setUsers] = useState(selected || []);
  // const [groups, setGroups] = useState([]);
  const elementRef = useRef();
  const [queryOptions, setQueryOptions] = useState({ per: 10 });
  const [loading, setLoading] = useState(false);
  // const [pagination, setPagination] = useState({});

  useEffect(() => {
    const el = elementRef.current;
    if (!el) return;

    const dragStartHandler = (event) => {
      if (!(event.target instanceof HTMLElement)) {
        event.preventDefault();
        return;
      }

      const card = event.target.closest(".draggable");
      if (!card) {
        event.preventDefault();
        return;
      }

      event.target.style.opacity = 1;

      const id = card.getAttribute("data-id");

      event.dataTransfer.clearData();
      event.dataTransfer.setData("text/plain", id);
      event.dataTransfer.effectAllowed = "all";
    };
    el.addEventListener("dragstart", dragStartHandler);

    return () => {
      el.removeEventListener("dragstart", dragStartHandler);
    };
  }, [elementRef]);

  // useEffect(() => {

  // AtriumApi.get("user-groups", { params: { q: queryOptions.q } }).then(
  //   (resp) => {
  //     setGroups(
  //       resp?.data?. ?.map((g) => ({
  //         ...g,
  //         count: resp?.data?.counts?.find((x) => x?.groupId === g?.id)
  //           ?.membersCount,
  //       }))
  //     );
  //   }
  // );
  // }, [queryOptions]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const query = {
          status: "active",
        };
        const response = await AtriumApi.get(
          `/v1/users?${new URLSearchParams(query).toString()}`,
          {
            params: queryOptions,
          }
        );
        if (response) {
          setLoading(false);
          setUsers(response?.data?.users);
        }
      } catch (error) {
        setLoading(false);
        console.error("Failed to fetch users:", error);
        toast.error(error?.response?.data?.message);
      }
    };

    fetchUsers();
  }, [queryOptions]);

  const sortedUsers = useMemo(() => {
    const missedUsers = selected?.filter(
      (user) => users?.findIndex((u) => u?.id === user?.id) === -1
    );
    return missedUsers.concat(users);
  }, [users, selected]);

  const toggleUser = (user) => {
    const index = selected?.findIndex((u) => u?.id === user?.id);
    if (index === -1) {
      setSelected(selected?.concat([user]));
    } else {
      setSelected(selected?.slice(0, index).concat(selected?.slice(index + 1)));
    }
  };

  const filterButtonStyle = (type) =>
    `inline-block text-sm py-2 rounded-full px-4 transition-all duration-200 ${
      (queryOptions.role || "") === type
        ? "bg-brand-500 text-white"
        : "bg-gray-100 text-gray-600 hover:bg-gray-50 dark:bg-navy-700 dark:hover:bg-navy-600"
    }`;
  return (
    <>
      <div className="pt-4">
        <div className="flex w-full h-12 items-center rounded-2xl bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white">
          <p className="pl-3 pr-2 text-xl">
            <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
          </p>
          <input
            type="text"
            placeholder="Search for people or departments"
            className="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark::placeholder:!text-gray-700"
            value={queryOptions.q || ""}
            onChange={(e) =>
              setQueryOptions({ ...queryOptions, q: e.target.value })
            }
          />
        </div>
      </div>

      <div className="flex flex-wrap gap-2 pt-4">
        <button
          className={filterButtonStyle("")}
          onClick={() => setQueryOptions({ ...queryOptions, role: "" })}
        >
          All
        </button>
        {/* <button className={filterButtonStyle('departments')} onClick={()=> setFilterType('departments')}>Departments</button> */}
        <button
          className={filterButtonStyle("member")}
          onClick={() => setQueryOptions({ ...queryOptions, role: "member" })}
        >
          Members
        </button>
        <button
          className={filterButtonStyle("volunteer")}
          onClick={() =>
            setQueryOptions({ ...queryOptions, role: "volunteer" })
          }
        >
          Volunteers
        </button>
      </div>

      {loading ? (
        <div className="flex items-center justify-center h-96">
          <Loader />
        </div>
      ) : (
        <>
          <div className="flex flex-col gap-1 pt-6" ref={elementRef}>
            {/* {groups?.length > 0
              ? users?.map((g) => (
                  <div
                    key={`g-${g?.id}`}
                    data-id={g?.id}
                    data-type="group"
                    draggable={draggable}
                    className="draggable flex hover:cursor-pointer content-center items-center gap-2 p-2 rounded-2xl hover:bg-gray-50 dark:hover:bg-navy-700 active:cursor-grabbing"
                  >
                    <div className="flex-1">
                      <div className="text-navy-700 font-bold text-sm dark:text-white">
                        {g?.name}
                      </div>
                      <div className="text-gray-600 text-xs">
                        {g?.count} members
                      </div>
                    </div>
                  </div>
                ))
              : null} */}

            {sortedUsers?.map((user) => (
              <div
                data-id={user?.id}
                data-type="user"
                onClick={() => toggleUser(user)}
                key={`user${user?.id}`}
                draggable={draggable}
                onDragStart={(e) => {
                  e.dataTransfer.clearData();
                  e.dataTransfer.setData("text/plain", user?.id);
                  e.dataTransfer.effectAllowed = "all";
                }}
                className={`draggable flex content-center items-center hover:cursor-pointer gap-2 p-2 rounded-2xl hover:bg-gray-100 dark:hover:bg-navy-700 ${
                  !draggable &&
                  selected?.findIndex((u) => u?.id === user?.id) !== -1 &&
                  "bg-gray-100 dark:bg-navy-700"
                }`}
              >
                <Avatar user={user} size="sm" />
                <div className="flex-1">
                  <div className="text-navy-700 font-bold text-sm dark:text-white">
                    {user?.firstName} {user?.lastName}
                  </div>
                  <div className="text-gray-600 text-xs capitalize">
                    {user?.role}
                  </div>
                </div>
                {!draggable &&
                  selected?.findIndex((u) => u.id === user.id) !== -1 && (
                    <span className="text-white bg-brand-500 rounded-full">
                      <CheckIcon />
                    </span>
                  )}
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default AssignForm;
